import Vue from "vue";
import axios from "axios";
import axiosHelper from "@/helpers/axios-helper";
import { createPresignedPost } from "@aws-sdk/s3-presigned-post";
import { S3Client } from "@aws-sdk/client-s3";
import { service_paths } from "@/constants/Services";
import { getFileNameObj } from "@/helpers/utils";
import { Message } from "./utils";
import InMemoryS3Credentials from "@/helpers/s3-inmemory-credentials";

const EXPIRE_PRESIGNED_URL = 600;
let url = process.env.VUE_APP_API_URL;

const getCredentials = async () => {
  try {
    const headers = await axiosHelper.getHeaderCfg();

    const { data: authData } = await axios({
      url: url + `${service_paths.awsS3}/get-auth-token`,
      method: "get",
      headers
    });

    const { status, ...credentialsData } = authData;
    InMemoryS3Credentials.persitCredentials({ ...credentialsData });

    return credentialsData;
  } catch (error) {
    Message.error(`Can't get credentials to upload file !`);
    throw error;
  }
};

const _generateS3FileName = orgFileName => {
  // const UUIDv4 = uuidv4().replace(/-/g, "");
  const { name, ext } = getFileNameObj(orgFileName);

  return `${name.replace(/\s+/g, "_")}.${ext}`;
};

const _generateBucketUrl = (bucket, region) =>
  `https://${bucket}.s3.${region}.amazonaws.com`;

const generatePresignedPost = async (s3FolderPath, orgFileName, contentType = 'application/octet-stream') => {
  try {
    const {
      credentials,
      package: packageData
    } = InMemoryS3Credentials.hasBeenInvalid()
      ? await getCredentials()
      : InMemoryS3Credentials.getCredentialData();

    const client = new S3Client({
      credentials: {
        accessKeyId: credentials.AccessKeyId,
        secretAccessKey: credentials.SecretAccessKey,
        sessionToken: credentials.SessionToken,
        expiration: credentials.Expiration
      },
      region: packageData.region
    });

    const url = _generateBucketUrl(packageData.bucket, packageData.region);
    const Bucket = packageData.bucket;
    const savingFileName = _generateS3FileName(orgFileName);

    const Key = `${s3FolderPath}/${savingFileName}`;

    // Note: this below function also generate url value
    const { fields } = await createPresignedPost(client, {
      Bucket,
      Key,
      Expires: EXPIRE_PRESIGNED_URL, //Seconds before the presigned post expires. 3600 by default.
      Fields: {
        "Content-Type": contentType // Setting Content-Type
      },
    });

    return {
      url,
      fields,
      savedPath: Key
    };
  } catch (error) {
    throw error;
  }
};

const postFileToS3 = async (s3FolderPath, file) => {
  try {
    const { url, fields, savedPath } = await generatePresignedPost(
      s3FolderPath,
      file.name,
      file.type
    );
    const formData = new FormData();

    for (let key in fields) {
      formData.append(key, fields[key]);
    }

    formData.append("file", file);

    console.log("url: ", url);

    await axios({
      url,
      method: "post",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

    const savedLink = `${url}/${savedPath}`;

    return savedLink;
  } catch (error) {
    Message.error(`Can't upload your file to S3`);

    console.group("[SAVE_FILE_TO_S3]");
    Vue.$log.error(error);
    console.groupEnd("[SAVE_FILE_TO_S3]");

    throw error;
  }
};

const saveUploadedLink = async (s3SavedLink, path, ...moreArg) => {
  try {
    const headers = await axiosHelper.getHeaderCfg();

    const data = {
      file_url: s3SavedLink,
      ...moreArg[0]
    };

    const res = await axios({
      url: url + path,
      method: "post",
      headers,
      data
    });

    return res;
  } catch (error) {
    Message.error(`Can't save your uploaded file link to database`);

    console.group("[SAVE_FILE_LINK]");
    Vue.$log.error(error);
    console.groupEnd("[SAVE_FILE_LINK]");
    throw error;
  }
};

export { postFileToS3, saveUploadedLink };
